import { render, staticRenderFns } from "./jinr-important.vue?vue&type=template&id=0c4d9ada&scoped=true"
import script from "./jinr-important.vue?vue&type=script&lang=js"
export * from "./jinr-important.vue?vue&type=script&lang=js"
import style0 from "./jinr-important.vue?vue&type=style&index=0&id=0c4d9ada&prod&lang=less"
import style1 from "./jinr-important.vue?vue&type=style&index=1&id=0c4d9ada&prod&lang=less&scoped=true"
import style2 from "./jinr-important.vue?vue&type=style&index=2&id=0c4d9ada&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d9ada",
  null
  
)

export default component.exports